import { render, staticRenderFns } from "./HeaderModality.vue?vue&type=template&id=2995d691"
import script from "./HeaderModality.vue?vue&type=script&lang=ts"
export * from "./HeaderModality.vue?vue&type=script&lang=ts"
import style0 from "./HeaderModality.vue?vue&type=style&index=0&id=2995d691&prod&lang=css"
import style1 from "./HeaderModality.vue?vue&type=style&index=1&id=2995d691&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports